module.exports = __webpack_public_path__ + "static/media/KimberleyEcho-devicecomp-min.53a4ec25.webp";